module.exports = __webpack_public_path__ + "img/ticket3_g.851e5fb3.svg";